// @ts-nocheck
import React, { useState, useRef, useEffect, useContext } from "react";
import { SHOW_PER_PAGE_SIGNATURES } from './config/featureFlags';
import authService from './authService';
import { savePage4DataHybrid, getPage4DataHybrid, getAllBookings, getPage1DataHybrid, getYachtItems, getMasterItems, getPage5Agreement } from './services/apiService';
import { savePageMedia } from './utils/mediaStorage';
import { DataContext } from './App';
import { isPastCheckoutGrace } from './utils/charterWindow';
import {
  compressImage,
  getBase64Size,
  compressImageWithLogging,
  compressSignature,
  brand,
  // EMPLOYEE_CODES, // removed - using authService
  uid,
  mid,
  I18N,
  saveBookingData,
  loadBookingData,
  savePage3Data,
  loadPage3Data,
  BookingInfoBox,
  SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES,
  TailwindButton,
  PageHeader,
  TopControls,
  ModeDisplay,
  ActionButtons,
  SignatureBox,
  TableSection
} from "./shared-components";
import DynamicBox from "./components/DynamicBox";

const VESSEL_NAME_TO_ID: Record<string, number> = {
  'bob': 8, 'perla': 7, 'infinity': 6, 'maria 1': 1,
  'maria 2': 2, 'bar bar': 4, 'kalispera': 5, 'valesia': 3
};

export const ITEM_LABELS = {
  lifejackets: { en: "lifejackets", el: "σωσίβια", it: "giubbotti di salvataggio", de: "Rettungswesten", ru: "спасательные жилеты", fr: "gilets de sauvetage", ro: "veste de salvare", pl: "kamizelki ratunkowe", he: "אפודי הצלה", es: "chalecos salvavidas" },
  flares: { en: "flares", el: "βοήθεια κινδύνου (flares)", it: "razzi di segnalazione", de: "Signalraketen", ru: "сигнальные ракеты", fr: "fusées de détresse", ro: "rachete de semnalizare", pl: "race sygnalizacyjne", he: "אבוקות מצוקה", es: "bengalas" },
  first_aid: { en: "first aid kit", el: "φαρμακείο", it: "kit pronto soccorso", de: "Erste-Hilfe-Set", ru: "аптечка", fr: "trousse de secours", ro: "trusă de prim ajutor", pl: "apteczka", he: "ערכת עזרה ראשונה", es: "botiquín" },
  fire_extinguisher: { en: "fire extinguisher", el: "πυροσβεστήρας", it: "estintore", de: "Feuerlöscher", ru: "огнетушитель", fr: "extincteur", ro: "stingător", pl: "gaśnica", he: "מטף כיבוי", es: "extintor" },
  liferaft: { en: "liferaft", el: "σωστική σχεδία", it: "zattera di salvataggio", de: "Rettungsinsel", ru: "спасательный плот", fr: "radeau de sauvetage", ro: "plută de salvare", pl: "tratwa ratunkowa", he: "רפסודת הצלה", es: "balsa salvavidas" },
  fog_horn: { en: "fog horn", el: "κόρνα ομίχλης", it: "corno da nebbia", de: "Nebelhorn", ru: "туманный горн", fr: "corne de brume", ro: "corn de ceață", pl: "sygnał mgłowy", he: "צופר ערפל", es: "bocina de niebla" },
  toolkit: { en: "toolkit", el: "εργαλεία", it: "cassetta attrezzi", de: "Werkzeugkasten", ru: "набор инструментов", fr: "boîte à outils", ro: "trusă de scule", pl: "zestaw narzędzi", he: "ארגז כלים", es: "caja de herramientas" },
  bed_linen: { en: "Bed linen for all cabins", el: "Κλινοσκεπάσματα για όλες τις καμπίνες", it: "biancheria da letto", de: "Bettwäsche", ru: "постельное бельё", fr: "linge de lit", ro: "lenjerie de pat", pl: "pościel", he: "מצעים", es: "ropa de cama" },
  pillows_cases: { en: "Pillows and Pillow cases", el: "Μαξιλάρια και μαξιλαροθήκες", it: "cuscini e federe", de: "Kissen und Bezüge", ru: "подушки и наволочки", fr: "oreillers et taies", ro: "perne și fețe de pernă", pl: "poduszki i poszewki", he: "כריות וציפיות", es: "almohadas y fundas" },
  blankets: { en: "Blankets", el: "Κουβέρτες", it: "coperte", de: "Decken", ru: "одеяла", fr: "couvertures", ro: "pături", pl: "koce", he: "שמיכות", es: "mantas" },
  bath_towels: { en: "Bath towels per person", el: "Πετσέτες μπάνιου ανά άτομο", it: "asciugamani da bagno", de: "Badetücher", ru: "банные полотенца", fr: "serviettes de bain", ro: "prosoape de baie", pl: "ręczniki kąpielowe", he: "מגבות אמבטיה", es: "toallas de baño" },
  tea_towels: { en: "Tea towels", el: "Πετσέτες κουζίνας", it: "strofinacci", de: "Geschirrtücher", ru: "кухонные полотенца", fr: "torchons", ro: "prosoape de bucătărie", pl: "ścierki kuchenne", he: "מגבות מטבח", es: "paños de cocina" },
  wc_mats: { en: "WC mats", el: "Χαλάκια WC", it: "tappetini WC", de: "WC-Matten", ru: "коврики WC", fr: "tapis WC", ro: "covorașe WC", pl: "maty WC", he: "שטיחוני שירותים", es: "alfombrillas WC" },
  spinnaker: { en: "Spinnaker", el: "Μπαλόνι (Spinnaker)", it: "spinnaker", de: "Spinnaker", ru: "спинакер", fr: "spinnaker", ro: "spinnaker", pl: "spinnaker", he: "ספינקר", es: "spinnaker" },
  snorkeling_gear: { en: "Snorkeling gear", el: "Εξοπλισμός snorkeling", it: "attrezzatura snorkeling", de: "Schnorchelausrüstung", ru: "снаряжение для снорклинга", fr: "équipement de snorkeling", ro: "echipament snorkeling", pl: "sprzęt do snorkelingu", he: "ציוד שנורקלינג", es: "equipo de snorkel" },
  fishing_equipment: { en: "Fishing equipment", el: "Εξοπλισμός ψαρέματος", it: "attrezzatura da pesca", de: "Angelausrüstung", ru: "рыболовное снаряжение", fr: "matériel de pêche", ro: "echipament de pescuit", pl: "sprzęt wędkarski", he: "ציוד דיג", es: "equipo de pesca" },
  bbq_grill: { en: "BBQ Grill", el: "Ψησταριά BBQ", it: "griglia BBQ", de: "BBQ-Grill", ru: "гриль BBQ", fr: "barbecue", ro: "grătar BBQ", pl: "grill BBQ", he: "גריל BBQ", es: "parrilla BBQ" },
  stand_up_paddle: { en: "Stand-up paddle", el: "SUP board", it: "SUP board", de: "SUP Board", ru: "SUP доска", fr: "paddle SUP", ro: "SUP board", pl: "deska SUP", he: "סאפ", es: "tabla SUP" },
  kayak: { en: "Kayak", el: "Καγιάκ", it: "kayak", de: "Kajak", ru: "каяк", fr: "kayak", ro: "caiac", pl: "kajak", he: "קיאק", es: "kayak" },
  control_gangway: { en: "Control Gangway", el: "Χειριστήριο πασαρέλας", it: "comando passerella", de: "Gangway-Steuerung", ru: "управление трапом", fr: "commande passerelle", ro: "comandă pasarelă", pl: "sterowanie trapem", he: "שלט פסרלה", es: "control pasarela" },
  control_tv: { en: "Control TV", el: "Χειριστήριο τηλεόρασης", it: "telecomando TV", de: "TV-Fernbedienung", ru: "пульт ТВ", fr: "télécommande TV", ro: "telecomandă TV", pl: "pilot TV", he: "שלט טלוויזיה", es: "control TV" },
  wifi_router: { en: "Wi-Fi Router", el: "Wi-Fi Router", it: "Wi-Fi Router", de: "Wi-Fi Router", ru: "Wi-Fi роутер", fr: "routeur Wi-Fi", ro: "router Wi-Fi", pl: "router Wi-Fi", he: "נתב Wi-Fi", es: "router Wi-Fi" },
  card_sd_gps: { en: "Card SD GPS Maker", el: "Κάρτα SD GPS Maker", it: "scheda SD GPS", de: "SD-Karte GPS", ru: "SD карта GPS", fr: "carte SD GPS", ro: "card SD GPS", pl: "karta SD GPS", he: "כרטיס SD GPS", es: "tarjeta SD GPS" },
  feet_for_saloon: { en: "Feet for Saloon", el: "Πόδια για σαλόνι", it: "piedini per salone", de: "Füße für Salon", ru: "ножки для салона", fr: "pieds pour salon", ro: "picioare pentru salon", pl: "nóżki do salonu", he: "רגליות לסלון", es: "patas para salón" },
  mattress: { en: "Mattress", el: "Στρώμα", it: "materasso", de: "Matratze", ru: "матрас", fr: "matelas", ro: "saltea", pl: "materac", he: "מזרן", es: "colchón" },
  espresso_machine: { en: "Espresso Machine", el: "Μηχανή Espresso", it: "macchina espresso", de: "Espressomaschine", ru: "кофемашина", fr: "machine à espresso", ro: "espressor", pl: "ekspres do kawy", he: "מכונת אספרסו", es: "cafetera espresso" },
  ice_maker: { en: "Ice Maker", el: "Παγομηχανή", it: "fabbricatore di ghiaccio", de: "Eismaschine", ru: "льдогенератор", fr: "machine à glaçons", ro: "aparat de gheață", pl: "kostkarka do lodu", he: "מכונת קרח", es: "máquina de hielo" },
  sea_scooter: { en: "Sea Scooter", el: "Θαλάσσιο σκούτερ", it: "scooter marino", de: "Unterwasser-Scooter", ru: "морской скутер", fr: "scooter sous-marin", ro: "scuter marin", pl: "skuter morski", he: "קטנוע ים", es: "scooter marino" }
};

function getLabel(key, lang) {
  return ITEM_LABELS[key]?.[lang] || ITEM_LABELS[key]?.['en'] || key;
}

// MASTER MERGE: render list = master_items keys + saved values per booking.
// Stale saved keys (no longer in master_items) are dropped. Missing keys get defaults.
const mergeWithMaster = (savedItems, masterKeys) => {
  if (!masterKeys || masterKeys.length === 0) return savedItems || [];
  const byKey = new Map((savedItems || []).map(it => [it.key || it.id, it]));
  return masterKeys.map(key => {
    const saved = byKey.get(key);
    if (saved) return { ...saved, key, id: saved.id || key };
    return { id: key, key, price: "", qty: 1, inOk: false, out: null, media: [] };
  });
};

// ========= Main Page3 Component =========
export default function Page3({ onNavigate }: { onNavigate?: (direction: string) => void }) {
  const [lang, setLang] = useState(sessionStorage.getItem("yacht_lang") || "en");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [mode, setMode] = useState("in");
  const [currentBookingNumber, setCurrentBookingNumber] = useState("");
  const [bookingInfo, setBookingInfo] = useState(null);
  const [isEmployee, setIsEmployee] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [employeeCode, setEmployeeCode] = useState("");
  const [showEmployeeCode, setShowEmployeeCode] = useState(false);

  // 🔥 Read logged-in user (from Gate Page) on mount so role-gated sections appear without re-login
  useEffect(() => {
    let u: any = null;
    try { u = JSON.parse(sessionStorage.getItem('auth_current_user') || 'null'); } catch (e) { u = null; }
    if (!u) u = authService.getCurrentUser();
    if (u) {
      setIsEmployee(true);
      setCurrentEmployee({ ...(u.permissions || {}), role: u.role });
    }
  }, []);

  const [technicalCheckItems, setTechnicalCheckItems] = useState([]);
  const [sectionKeys, setSectionKeys] = useState({ technical_check: [] });
  const [keysLoaded, setKeysLoaded] = useState(false);
  const [masterLabels, setMasterLabels] = useState({}); // item_key → {el,en,it,de,ru,fr,ro,pl,he,es}
  // Per-mode hide (master_items): hide_checkin hides in check-in, hide_checkout hides in check-out.
  // Fallback: legacy checkout_only → treated as hide_checkin.
  const isTrueFlag = (v: any) => v === true || v === 't' || v === 'true' || v === 1 || v === '1';
  const hideCheckinKeysRef = useRef(new Set());
  const hideCheckoutKeysRef = useRef(new Set());
  const visTechKeys = (keys, m) => m === 'in'
    ? (keys || []).filter(k => !hideCheckinKeysRef.current.has(k))
    : (keys || []).filter(k => !hideCheckoutKeysRef.current.has(k));
  const visTechItems = (arr, m) => m === 'in'
    ? (arr || []).filter(it => !hideCheckinKeysRef.current.has(it.key))
    : (arr || []).filter(it => !hideCheckoutKeysRef.current.has(it.key));

  // 🔒 SNAPSHOT (v6.175 / ΕΠΙΛΟΓΗ 3): isFrozen=true when this booking+mode has a
  // submitted page5_agreement row WITH an items_snapshot.page4.technical_check payload.
  // When frozen: read-only render from snapshot, skip yacht_items/page4_checklist merge.
  const [isFrozen, setIsFrozen] = useState(false);
  // frozenHydrated: true ONLY when technicalCheckItems were hydrated from a non-empty
  // snapshot. Gates the live-load effects; isFrozen (read-only UI) must NOT block live load.
  const [frozenHydrated, setFrozenHydrated] = useState(false);
  const [frozenLabels, setFrozenLabels] = useState<Record<string, any>>({});

  // Load canonical key list per section from master_items (one-time, global)
  useEffect(() => {
    (async () => {
      try {
        const masterItems = await getMasterItems(undefined, 'page4');
        const grouped = { technical_check: [] };
        const labelsMap = {};
        const hideInSet = new Set();
        const hideOutSet = new Set();
        for (const mi of (masterItems || [])) {
          if (mi.active === false) continue;
          if (grouped[mi.section]) grouped[mi.section].push(mi.item_key);
          if (isTrueFlag(mi.hide_checkin) || isTrueFlag(mi.checkout_only)) hideInSet.add(mi.item_key);
          if (isTrueFlag(mi.hide_checkout)) hideOutSet.add(mi.item_key);
          labelsMap[mi.item_key] = {
            el: mi.label_el, en: mi.label_en, it: mi.label_it, de: mi.label_de,
            ru: mi.label_ru, fr: mi.label_fr, ro: mi.label_ro, pl: mi.label_pl,
            he: mi.label_he, es: mi.label_es
          };
        }
        hideCheckinKeysRef.current = hideInSet;
        hideCheckoutKeysRef.current = hideOutSet;
        setSectionKeys(grouped);
        setMasterLabels(labelsMap);
        console.log('Dynamic Page 4: master_items loaded', grouped, 'hide-in:', hideInSet.size, 'hide-out:', hideOutSet.size);
      } catch (err) {
        console.error('Dynamic Page 4: master_items load failed', err);
      } finally {
        setKeysLoaded(true);
      }
    })();
  }, []);
  const [notes, setNotes] = useState("");
  const [signatureImage, setSignatureImage] = useState("");
  
  const [toiletWarningAccepted, setToiletWarningAccepted] = useState(false);
  const [checkInStartedAt, setCheckInStartedAt] = useState(null);
  const savedStartRef = useRef(false);

  // 🔥 BUG 1 FIX: Reset mode-non-specific flag on mode change to prevent Select All carry-over
  useEffect(() => {
    setToiletWarningAccepted(false);
  }, [mode]);
  
  const [showCamera, setShowCamera] = useState(false);
  const [currentItemId, setCurrentItemId] = useState(null);
  const [zoomUrl, setZoomUrl] = useState(null);
  
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);

  // 🔥 Detect booking change WITHOUT localStorage (App.tsx writes localStorage before we see context)
  const prevBookingRef = useRef(null);
  
  const t = I18N[lang];
  // 🔒 Frozen labels (from snapshot) win when present — keeps submitted UI/PDF i18n stable
  //    even if admin renames items in master_items afterwards.
  const getLabelLocal = (key) => frozenLabels[key]?.[lang] || masterLabels[key]?.[lang] || getLabel(key, lang);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Get context data
  const contextData = useContext(DataContext);

  // 🔒 SNAPSHOT detection — must run before/regardless of live load.
  // Detects submitted state by presence of page5_agreement row + items_snapshot.page4 for this (booking, mode).
  // On hit: hydrate technicalCheckItems + frozenLabels directly from snapshot, mark isFrozen=true.
  // On miss: ensure isFrozen=false so live paths run as before.
  useEffect(() => {
    if (!keysLoaded) return;
    const bn = contextData?.bookingNumber || localStorage.getItem('currentBooking');
    const m = (contextData?.mode || 'in') as 'in' | 'out';
    if (!bn) { setIsFrozen(false); return; }
    let cancelled = false;
    (async () => {
      try {
        const ag = await getPage5Agreement(bn);
        const row = m === 'in' ? ag?.checkIn : ag?.checkOut;
        const snap = row?.items_snapshot?.page4?.technical_check;
        // submitted = agreement row exists AND finalized (email actually sent — genuine submit).
        const submitted = !!row && row.email_sent === true;
        if (cancelled) return;
        let coDateP4 = '';
        let coTimeP4 = '';
        try {
          const p1x = await getPage1DataHybrid(bn);
          coDateP4 = (p1x as any)?.checkOutDate || '';
          coTimeP4 = (p1x as any)?.checkOutTime || '';
        } catch (eP1x) { coDateP4 = ''; coTimeP4 = ''; }
        const graceFrozenP4 = (d: boolean) => d && (!coDateP4 || isPastCheckoutGrace(coDateP4, coTimeP4, 1));
        if (Array.isArray(snap) && snap.length > 0) {
          setTechnicalCheckItems(snap.map((s: any) => ({
            id: uid(),
            key: s.item_key,
            price: s.price ?? "",
            qty: s.qty ?? 1,
            inOk: !!s.inOk,
            out: s.out ?? null,
            media: s.media || []
          })));
          const lblMap: Record<string, any> = {};
          for (const s of snap) { if (s && s.labels) lblMap[s.item_key] = s.labels; }
          setFrozenLabels(lblMap);
          setFrozenHydrated(true);
          setIsFrozen(graceFrozenP4(submitted));
          console.log('🔒 Page 4: snapshot loaded for', bn, m, '— rows:', snap.length);
        } else if (submitted) {
          // Submitted but page4 snapshot empty/missing (transient capture failure).
          // Freeze read-only but DO NOT hydrate: keep LIVE page4_checklist as source of truth.
          setFrozenHydrated(false);
          setIsFrozen(graceFrozenP4(submitted));
        } else {
          setFrozenHydrated(false);
          setIsFrozen(false);
        }
      } catch (e) {
        console.warn('Page 4 snapshot check failed (treating as not frozen):', e);
        if (!cancelled) setIsFrozen(false);
      }
    })();
    return () => { cancelled = true; };
  }, [contextData?.bookingNumber, contextData?.mode, keysLoaded]);

  useEffect(() => {
    if (!keysLoaded) return;
    if (frozenHydrated) return; // 🔒 frozen path is authoritative; skip live load
    const loadBookingFromAPI = async () => {
      // Use currentBooking from localStorage (UI state) or context
      const currentBooking = contextData?.bookingNumber || localStorage.getItem('currentBooking');

      if (currentBooking) {
        try {
          // 🔥 FIX: First get vessel/skipper data from Page 1 API (source of truth)
          const page1Data = await getPage1DataHybrid(currentBooking);
          console.log('📍 Page 3: Loaded Page 1 data:', page1Data);

          // Fetch booking info from API
          const allBookings = await getAllBookings();
          const booking = allBookings.find((b: any) =>
            b.bookingNumber === currentBooking || b.code === currentBooking
          );

          if (booking || page1Data) {
            setCurrentBookingNumber(currentBooking);

            // 🔥 FIX: Merge booking info, prioritizing Page 1 data (source of truth for vessel/skipper/dates)
            const mergedBookingInfo = {
              ...booking,
              vesselName: page1Data?.vesselName || booking?.vesselName || booking?.vessel,
              skipperFirstName: page1Data?.skipperFirstName || booking?.skipperFirstName,
              skipperLastName: page1Data?.skipperLastName || booking?.skipperLastName,
              checkInDate: page1Data?.checkInDate || booking?.checkInDate,
              checkOutDate: page1Data?.checkOutDate || booking?.checkOutDate,
            };
            setBookingInfo(mergedBookingInfo);

            const savedMode = contextData?.mode || booking?.mode || page1Data?.mode || 'in';
            setMode(savedMode);
            loadDataForMode(currentBooking, savedMode);

            console.log(`✅ Loaded booking from API: ${currentBooking}, Mode: ${savedMode}`);
          } else {
            console.warn(`⚠️ Booking ${currentBooking} not found in API`);
          }
        } catch (error) {
          console.error('❌ Error loading booking from API:', error);
        }
      } else {
        console.warn('⚠️ No current booking set');
      }
    };

    loadBookingFromAPI();
  }, [contextData?.bookingNumber, contextData?.mode, keysLoaded, isFrozen, sectionKeys]);

  // 🔥 Reset data if booking number changed (useRef-based — no localStorage; multi-tenant safe)
  useEffect(() => {
    const bn = contextData?.bookingNumber || '';
    if (!bn) return;
    if (prevBookingRef.current !== null && prevBookingRef.current !== bn) {
      console.log(`🔄 Page4 booking changed: ${prevBookingRef.current} → ${bn} - RESETTING all data`);
      // 🔒 Clear frozen flags so the new booking re-evaluates snapshot from scratch.
      setIsFrozen(false);
      setFrozenHydrated(false);
      setFrozenLabels({});
      setTechnicalCheckItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setNotes("");
      setSignatureImage("");
      setToiletWarningAccepted(false);
    }
    prevBookingRef.current = bn;
  }, [contextData?.bookingNumber]);

  // 🔥 PHASE 3: Load items from yacht_items DB per vessel
  useEffect(() => {
    if (!keysLoaded) return;
    if (frozenHydrated) return; // 🔒 frozen snapshot wins; never overwrite with yacht_items defaults
    const vName = (bookingInfo?.vesselName || contextData?.data?.vesselName || '').toLowerCase().trim();
    if (!vName) return;

    const vesselId = VESSEL_NAME_TO_ID[vName];
    if (!vesselId) {
      console.warn('Phase 3 Page 4: Unknown vessel', vName);
      return;
    }

    const SECTION_TO_SETTER = {
      technical_check: setTechnicalCheckItems,
    };

    const SECTION_FALLBACK_KEYS = {};

    const inlineInit = (keys) => keys.map(key => ({
      id: uid(), key, price: "", qty: 1, inOk: false, out: null, media: []
    }));

    (async () => {
      try {
        // GUARD: Skip yacht_items default load if saved data exists
        const guardMode = contextData?.mode || 'in';
        if (currentBookingNumber) {
          try {
            const savedData = await getPage4DataHybrid(currentBookingNumber, guardMode);
            if (savedData && ((savedData.technicalCheckItems && savedData.technicalCheckItems.length > 0) || (savedData.items && savedData.items.length > 0))) {
              console.log('✋ Phase 3 Page 4: Skipping yacht_items defaults — saved data exists');
              // Backfill technical_check ΜΟΝΟ αν λείπει/άδειο από saved (legacy bookings pre-v6.96)
              if (!savedData.technicalCheckItems || savedData.technicalCheckItems.length === 0) {
                try {
                  const yachtItemsTC = await getYachtItems(vesselId);
                  const activeTC = (yachtItemsTC || []).filter(yi => yi.active && yi.section === 'technical_check');
                  if (activeTC.length > 0) {
                    setTechnicalCheckItems(activeTC.map(yi => ({
                      id: uid(),
                      key: yi.item_key,
                      price: yi.price != null ? String(yi.price) : "",
                      qty: yi.qty != null ? Number(yi.qty) : 1,
                      inOk: false,
                      out: null,
                      media: []
                    })));
                    console.log('🔧 Backfilled technical_check defaults for legacy booking');
                  }
                } catch (e) {
                  console.warn('Failed to backfill technical_check defaults:', e);
                }
              }
              return;
            }
          } catch (e) {
            console.warn('Phase 3 Page 4: guard check failed, proceeding with defaults', e);
          }
        }
        // include_inactive=true: rawGrouped needs to see inactive rows to detect
        // "section is managed but all unchecked" vs "section never seeded".
        const yachtItems = await getYachtItems(vesselId, undefined, true);
        const activeItems = (yachtItems || []).filter(yi => yi.active);

        const grouped = { technical_check: [] };
        // Raw grouping (active+inactive) — distinguishes "section is DB-managed" from "never seeded"
        const rawGrouped = { technical_check: [] };
        for (const yi of (yachtItems || [])) {
          if (rawGrouped[yi.section]) rawGrouped[yi.section].push(yi);
        }

        for (const yi of activeItems) {
          if (grouped[yi.section]) {
            grouped[yi.section].push({
              id: uid(),
              key: yi.item_key,
              price: yi.price != null ? String(yi.price) : "",
              qty: yi.qty != null ? Number(yi.qty) : 1,
              inOk: false,
              out: null,
              media: []
            });
          }
        }

        // Fallback ONLY when section has zero rows in DB (never seeded).
        // If admin unchecked all items → respect empty list.
        // Also rewrite sectionKeys per-vessel so downstream mergeWithMaster()
        // doesn't reintroduce inactive items from the cross-vessel master_items list.
        const vesselSectionKeys = {};
        for (const section of Object.keys(SECTION_TO_SETTER)) {
          const setter = SECTION_TO_SETTER[section];
          if (rawGrouped[section].length > 0) {
            setter(visTechItems(grouped[section], mode));
            vesselSectionKeys[section] = activeItems
              .filter(yi => yi.section === section)
              .map(yi => yi.item_key);
          } else {
            setter(inlineInit(SECTION_FALLBACK_KEYS[section]));
          }
        }
        if (Object.keys(vesselSectionKeys).length > 0) {
          setSectionKeys(prev => ({ ...prev, ...vesselSectionKeys }));
        }

        console.log('🔥 Phase 3 Page 4: Loaded items from DB for vessel', vName, 'vessel_id', vesselId);
      } catch (err) {
        console.warn('⚠️ Phase 3 Page 4: yacht_items API failed, using hardcoded fallback:', err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingInfo?.vesselName, contextData?.data?.vesselName, keysLoaded, currentBookingNumber, isFrozen]);
  // 🔥 END PHASE 3

  const loadDataForMode = async (bookingNumber, selectedMode) => {
    // 🔒 SNAPSHOT: if this (booking, mode) is frozen, the snapshot effect already
    // hydrated technicalCheckItems. Do nothing here so we don't overwrite with live data.
    if (frozenHydrated) return;

    // 🔥 Try API first, then localStorage fallback
    let loaded = null;

    // 🔥 FIX: When in check-out mode, first load check-in data to get inOk values.
    // 🔒 Prefer the FROZEN check-in snapshot when it exists (legal source of truth);
    //    fall back to live page4_checklist 'in' only for legacy bookings without snapshot.
    let checkInTechnicalItems = null;

    if (selectedMode === 'out') {
      try {
        const ag = await getPage5Agreement(bookingNumber);
        const snap = ag?.checkIn?.items_snapshot?.page4?.technical_check;
        if (Array.isArray(snap) && snap.length > 0) {
          checkInTechnicalItems = snap.map((s: any) => ({
            id: uid(),
            key: s.item_key,
            price: s.price ?? "",
            qty: s.qty ?? 1,
            inOk: !!s.inOk,
            out: null,
            media: s.media || []
          }));
          console.log('🔒 Check-out base sourced from frozen check-in snapshot (rows:', snap.length, ')');
        }
      } catch (e) {
        console.warn('⚠️ Failed to read check-in snapshot for check-out base:', e);
      }
      if (!checkInTechnicalItems) {
        try {
          const checkInData = await getPage4DataHybrid(bookingNumber, 'in');
          if (checkInData) {
            checkInTechnicalItems = checkInData.technicalCheckItems;
            console.log('✅ Page 4 check-in (live) data loaded for inOk values (no snapshot yet)');
          }
        } catch (error) {
          console.warn('⚠️ Failed to load check-in data for inOk merge:', error);
        }
      }
    }

    // Helper function to merge inOk from check-in data with current mode data
    const mergeInOkData = (currentItems, checkInItemsData, defaultKeys) => {
      if (!currentItems && !checkInItemsData) return null;

      // If we have current mode items, merge inOk from check-in
      if (currentItems && checkInItemsData) {
        return currentItems.map(item => {
          const checkInItem = checkInItemsData.find(ci => ci.key === item.key);
          return { ...item, inOk: checkInItem?.inOk || item.inOk || false };
        });
      }

      // If only check-in items exist (starting checkout), use them as base — preserve inOk for reference
      if (checkInItemsData) {
        return checkInItemsData.map(item => ({ ...item, out: null }));
      }

      return currentItems;
    };

    try {
      const apiData = await getPage4DataHybrid(bookingNumber, selectedMode);
      if (apiData) {
        console.log('✅ Page 3 data loaded from API');
        loaded = apiData;
      }
    } catch (error) {
      console.warn('⚠️ API load failed, using localStorage:', error);
    }

    // Fallback to localStorage
    if (!loaded) {
      loaded = loadPage3Data(bookingNumber, selectedMode);
    }

    if (loaded) {
      // Apply mode='out' inOk/photo merge first (preserved), then master filter
      const technicalAfterInOk = selectedMode === 'out'
        ? mergeInOkData(loaded.technicalCheckItems, checkInTechnicalItems, sectionKeys.technical_check)
        : loaded.technicalCheckItems;

      setTechnicalCheckItems(mergeWithMaster(technicalAfterInOk, visTechKeys(sectionKeys.technical_check, selectedMode)));
      setNotes(loaded.notes || "");
      setSignatureImage(loaded.signature || "");
      setToiletWarningAccepted(loaded.toiletWarningAccepted || false);
      setCheckInStartedAt(loaded.checkInStartedAt || null);
    } else if (selectedMode === 'out' && checkInTechnicalItems) {
      // 🔥 FIX: No check-out data yet, but we have check-in data - use it as starting point
      console.log('🔄 Using check-in data as base for check-out');
      // 🔥 INDEPENDENCE FIX: reset out (inOk inherits from check-in for reference column)
      setTechnicalCheckItems(mergeWithMaster(checkInTechnicalItems ? checkInTechnicalItems.map(item => ({ ...item, out: null })) : [], visTechKeys(sectionKeys.technical_check, selectedMode)));
      setNotes("");
      setSignatureImage("");
      setToiletWarningAccepted(false);
    } else {
      // PHASE 3.1: Keep Phase 3 DB-loaded items if already populated; only reset when truly empty
      setTechnicalCheckItems(prev => prev.length ? prev : initItems(visTechKeys(sectionKeys.technical_check, selectedMode)));
      setNotes("");
      setSignatureImage("");
      setToiletWarningAccepted(false);
    }
  };

  const initItems = (keys) => keys.map(key => ({ id: uid(), key, price: "", qty: 1, inOk: false, out: null, media: [] }));

  const setPrice = (id, value) => {
    setTechnicalCheckItems(prev => prev.map(it => it.id === id ? {...it, price: value} : it));
  };

  const incQty = (id) => {
    setTechnicalCheckItems(prev => prev.map(it => it.id === id ? {...it, qty: (it.qty || 1) + 1} : it));
  };

  const decQty = (id) => {
    setTechnicalCheckItems(prev => prev.map(it => it.id === id ? {...it, qty: Math.max(1, (it.qty || 1) - 1)} : it));
  };

  // 🔥 SIMPLE TOGGLE (match page 2): always toggles, works check-in AND check-out
  const toggleInOk = (id) => {
    if (mode === 'in') setCheckInStartedAt(prev => prev || new Date().toISOString());
    const toggle = (prev) => prev.map((it) => (it.id === id ? { ...it, inOk: !it.inOk } : it));
    setTechnicalCheckItems(toggle);
  };

  // ⏱️ CHECK-IN DURATION: μόλις οριστεί το START (πρώτο mark), σώσε το ΜΙΑ φορά (immediate).
  useEffect(() => {
    if (mode === 'in' && checkInStartedAt && !savedStartRef.current && currentBookingNumber) {
      savedStartRef.current = true;
      const startSave = { technicalCheckItems, notes, signature: signatureImage, toiletWarningAccepted, checkInStartedAt };
      savePage4DataHybrid(currentBookingNumber, startSave, 'in').catch(() => {});
    }
  }, [checkInStartedAt]);

  const setOut = (id, value) => {
    setTechnicalCheckItems(prev => prev.map(it => it.id === id ? {...it, out: value} : it));
  };

  const handlers = {
    openCamera: (itemId) => {
      setCurrentItemId(itemId);
      setShowCamera(true);
      setTimeout(async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
          if (videoRef.current) videoRef.current.srcObject = stream;
        } catch (err) {
          console.error('Camera error:', err);
          alert(t.cameraError || 'Camera access denied');
        }
      }, 100);
    },
    handleFiles: async (itemId, files) => {
      const file = files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        const compressed = await compressImageWithLogging(e.target.result);
        setTechnicalCheckItems(prev => prev.map(it => it.id === itemId ? {...it, media: [...(it.media || []), { id: mid(), url: compressed }]} : it));
      };
      reader.readAsDataURL(file);
    },
    openFilePicker: (itemId) => {
      setCurrentItemId(itemId);
      fileInputRef.current?.click();
    },
    removeRow: (id) => {
      if (window.confirm(t.confirmDelete || "Delete this item?")) {
        setTechnicalCheckItems(prev => prev.filter(it => it.id !== id));
      }
    }
  };

  const capturePhoto = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!canvas || !video) return;
    
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    
    const base64 = canvas.toDataURL('image/jpeg', 0.8);
    const compressed = await compressImageWithLogging(base64);
    
    setTechnicalCheckItems(prev => prev.map(it => it.id === currentItemId ? {...it, media: [...(it.media || []), { id: mid(), url: compressed }]} : it));
    
    const stream = video.srcObject;
    stream?.getTracks().forEach(track => track.stop());
    setShowCamera(false);
  };

  const closeCamera = () => {
    const video = videoRef.current;
    const stream = video?.srcObject;
    stream?.getTracks().forEach(track => track.stop());
    setShowCamera(false);
  };

  const removeMedia = (itemId, mediaId) => {
    setTechnicalCheckItems(prev => prev.map(it => it.id === itemId ? {...it, media: it.media.filter(m => m.id !== mediaId)} : it));
  };

  // 🔥 Percentage: TECHNICAL_CHECK only (74 items)
  const requiredItems = [...technicalCheckItems];
  const totalItems = requiredItems.length;
  let completedItems = 0;
  if (mode === "in") {
    completedItems = requiredItems.filter((it) => it.inOk).length;
  } else {
    completedItems = requiredItems.filter((it) => it.out === "ok" || it.out === "not").length;
  }
  const percentage = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  // 🔥 allItems για media (όλα τα items)
  const allItems = [...technicalCheckItems];

  const handleEmployeeLogin = () => {
    const user = authService.login(employeeCode);
    if (user) {
      setIsEmployee(true);
      setCurrentEmployee(user.permissions);
      setShowLoginModal(false);
      setEmployeeCode("");
    } else {
      alert(t.invalidCode);
    }
  };

  const handleEmployeeLogout = () => {
    setIsEmployee(false);
    setCurrentEmployee(null);
  };

  const highlightError = (id) => {
    const row = document.getElementById(`row-${id}`);
    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      row.style.backgroundColor = '#fee2e2';
      row.style.transition = 'background-color 0.3s';
      setTimeout(() => {
        row.style.backgroundColor = '';
      }, 3000);
    }
  };

  const handleSave = async () => {
    if (isFrozen) {
      // 🔒 Submitted bookings are immutable from Page 4. No-op (button is also hidden in JSX).
      return;
    }
    if (!isEmployee || !currentEmployee?.canEdit) {
      alert(t.employeeRequired || '🔒 Employee permissions required!');
      return;
    }

    const dataToSave = {
      technicalCheckItems,
      notes,
      signature: signatureImage,
      toiletWarningAccepted,
      checkInStartedAt
    };

    // ✅ Save to Page 3 API using hybrid function
    try {
      const result = await savePage4DataHybrid(currentBookingNumber, dataToSave, mode);

      // Also save via shared function for backward compatibility
      savePage3Data(currentBookingNumber, dataToSave, mode);

      // 🔥 Save media to localStorage separately (API may not store large base64 images)
      savePageMedia(currentBookingNumber, mode, 'page3', [...technicalCheckItems]);

      if (result.synced) {
        alert(t.draftSavedSynced || '✅ Saved and synced!');
      } else {
        alert(t.draftSavedLocally || '✅ Saved locally!');
      }
    } catch (error) {
      console.error('Error saving:', error);
      alert(t.saveError || '❌ Save error!');
    }
  };

  const handlePrevious = () => {
    if (onNavigate && typeof onNavigate === 'function') {
      onNavigate('prev');
    }
  };

  const handleSelectAllOk = () => {
    const confirmed = window.confirm(t.selectAllOkConfirm || 'Under my own responsibility I declare all items are correct. Continue?');
    if (!confirmed) return;
    if (mode === 'in') {
      setCheckInStartedAt(prev => prev || new Date().toISOString());
      setTechnicalCheckItems(prev => prev.map(it => ({ ...it, inOk: true })));
    } else {
      setTechnicalCheckItems(prev => prev.map(it => ({ ...it, out: 'ok' })));
    }
    setToiletWarningAccepted(true);
  };

  const handleNext = async () => {
    // 🔒 Frozen view: skip validation/save and simply navigate. Snapshot is immutable.
    if (isFrozen) {
      if (onNavigate && typeof onNavigate === 'function') onNavigate('next');
      return;
    }
    // ORPHAN consent check removed: toilet_warning moved to page_group=page3 and is now
    // enforced dynamically there (config-aware). The page4 box no longer exists.

    if (SHOW_PER_PAGE_SIGNATURES && !signatureImage) {
      alert(t.signatureRequired || 'Please provide signature!');
      return;
    }

    const dataToSave = {
      technicalCheckItems,
      notes,
      signature: signatureImage,
      toiletWarningAccepted,
      checkInStartedAt
    };

    try {
      await savePage4DataHybrid(currentBookingNumber, dataToSave, mode);
      savePage3Data(currentBookingNumber, dataToSave, mode);

      if (onNavigate && typeof onNavigate === 'function') {
        onNavigate('next');
      }
    } catch (error) {
      alert(t.saveError || 'Save error!');
    }
  };

  const handlePDF = () => {
    if (!bookingInfo) {
      alert(t.noActiveBooking || '❌ No active booking!');
      return;
    }

    try {
      // Import PDF generator
      const { generateLuxuryPDF } = require('./utils/LuxuryPDFGenerator');
      
      // 🔥 Read signature with CORRECT key format
      const signatureKey = `page3_signature_${currentBookingNumber}_${mode}`;
      const actualSignature = localStorage.getItem(signatureKey) || '';
      
      console.log('📝 Signature from localStorage:', {
        key: signatureKey,
        type: typeof actualSignature,
        length: actualSignature?.length,
        startsWithData: typeof actualSignature === 'string' && actualSignature.startsWith('data:')
      });
      
      // 🔥 Pass data με τον ΙΔΙΟ τρόπο που περνάει η Σελίδα 2
      const additionalData = {
        technical_check: technicalCheckItems,
        toiletWarningAccepted: toiletWarningAccepted,
        skipperSignature: actualSignature  // Use actual signature from localStorage
      };
      
      const pdf = generateLuxuryPDF(
        bookingInfo, 
        mode, 
        additionalData, 
        lang, 
        { isPage3: true }
      );
      
      const fileName = `${bookingInfo.bookingNumber || 'booking'}_Page3_${mode}_${Date.now()}.pdf`;
      pdf.save(fileName);
      
      alert(t.pdfGenerated || '✅ PDF generated!');
    } catch (error) {
      console.error('PDF generation error:', error);
      alert(t.pdfError || '❌ PDF generation error!');
    }
  };

  // Get all media from all items
  const allMedia = allItems.reduce((acc, item) => {
    if (item.media && item.media.length > 0) {
      return [...acc, ...item.media.map(m => ({ ...m, itemKey: item.key }))];
    }
    return acc;
  }, []);

  return (
    <div className="min-h-screen p-4" style={{ backgroundColor: brand.pageBg }}>
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        
        {SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES && <BookingInfoBox bookingInfo={bookingInfo} currentBookingNumber={currentBookingNumber} />}
        <TailwindButton />
        <PageHeader title={t.title} />
        <ModeDisplay mode={mode} t={t} />
        <TopControls
          isOnline={isOnline}
          lang={lang}
          setLang={setLang}
          isEmployee={isEmployee}
          currentEmployee={currentEmployee}
          onEmployeeLogout={handleEmployeeLogout}
          onEmployeeLogin={() => setShowLoginModal(true)}
          percentage={percentage}
          hideEmployeeLogin={true}
          hideEmployeeLogout={true}
        />

        {/* 📊 v6.478 — ΔΕΙΚΤΗΣ ΠΡΟΟΔΟΥ. Φαίνεται ΠΡΙΝ φτάσει ο υπάλληλος στο Submit,
            ώστε να μη νομίζει ποτέ ξανά ότι τελείωσε ενώ λείπουν 54 στοιχεία. */}
        <div
          style={{
            position: 'sticky', top: 0, zIndex: 30,
            marginBottom: 16, padding: '12px 14px', borderRadius: 12,
            border: '2px solid ' + (completedItems >= totalItems && totalItems > 0 ? '#16a34a' : '#dc2626'),
            background: completedItems >= totalItems && totalItems > 0 ? '#f0fdf4' : '#fef2f2',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: completedItems >= totalItems && totalItems > 0 ? '#15803d' : '#b91c1c' }}>
              {completedItems >= totalItems && totalItems > 0 ? '✅' : '⚠️'} {completedItems}/{totalItems}{' '}
              {lang === 'el' ? 'συμπληρωμένα' : 'completed'}
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#b91c1c' }}>
              {totalItems - completedItems > 0
                ? (lang === 'el'
                    ? 'Λείπουν ' + (totalItems - completedItems) + ' στοιχεία'
                    : (totalItems - completedItems) + ' items missing')
                : (lang === 'el' ? 'Όλα συμπληρωμένα' : 'All completed')}
            </div>
          </div>
          <div style={{ marginTop: 8, height: 10, borderRadius: 6, background: '#e5e7eb', overflow: 'hidden' }}>
            <div
              style={{
                width: percentage + '%', height: '100%',
                background: completedItems >= totalItems && totalItems > 0 ? '#16a34a' : '#dc2626',
                transition: 'width 0.25s ease',
              }}
            />
          </div>
        </div>

        <input 
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => handlers.handleFiles(currentItemId, e.target.files)}
        />


        {isEmployee && !isFrozen && (
          <div className="mb-4 text-center">
            <button
              onClick={handleSelectAllOk}
              className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow-md"
            >
              ✓ {t.selectAllOk || 'SELECT ALL OK'}
            </button>
          </div>
        )}



        <TableSection
          data={technicalCheckItems}
          t={t}
          setPrice={setPrice}
          incQty={incQty}
          decQty={decQty}
          toggleInOk={toggleInOk}
          setOut={setOut}
          openCamera={handlers.openCamera}
          handleFiles={handlers.handleFiles}
          openFilePicker={handlers.openFilePicker}
          removeRow={handlers.removeRow}
          mode={mode}
          getLabel={(key) => getLabelLocal(key)}
          isEmployee={isEmployee}
          currentEmployee={currentEmployee}
          readOnly={isFrozen || !isEmployee}
          sectionTitle={({en:'TECHNICAL CHECK',el:'ΤΕΧΝΙΚΟΣ ΕΛΕΓΧΟΣ',it:'CONTROLLO TECNICO',de:'TECHNISCHE PRÜFUNG',ru:'ТЕХНИЧЕСКАЯ ПРОВЕРКА',fr:'CONTRÔLE TECHNIQUE',ro:'VERIFICARE TEHNICĂ',pl:'KONTROLA TECHNICZNA',he:'בדיקה טכנית',es:'CONTROL TÉCNICO'})[lang] || 'TECHNICAL CHECK'}
        />

        <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
          <label className="block font-semibold" style={{ color: brand.black }}>{t.note}</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            readOnly={isFrozen}
            className="mt-2 w-full border rounded p-3 min-h-[180px] bg-white"
            placeholder={t.notePH}
            style={{ borderColor: brand.black, color: brand.black }}
          />
        </div>

        {/* PHOTO GALLERY - ALWAYS SHOW BOX */}
        <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
          <label className="block font-semibold mb-3" style={{ color: brand.black }}>
            {t.picsTitle}
          </label>
          
          {allMedia.length > 0 ? (
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
              {allMedia.map((media) => (
                <div key={media.id} className="relative border-2 rounded-lg overflow-hidden" style={{ borderColor: brand.black }}>
                  <img 
                    src={media.url} 
                    alt={getLabelLocal(media.itemKey)}
                    className="w-full h-24 object-cover cursor-pointer"
                    onClick={() => setZoomUrl(media.url)}
                  />
                  <div className="absolute top-1 right-1 flex gap-1">
                    <button 
                      onClick={() => setZoomUrl(media.url)}
                      className="bg-white rounded-full p-1 shadow-md hover:bg-gray-100"
                    >
                      🔍
                    </button>
                    {!isFrozen && (
                      <button
                        onClick={() => {
                          // Find the correct section and item
                          const sectionMappings = [
                            { data: technicalCheckItems, key: 'technical_check' }
                          ];

                          for (const { data } of sectionMappings) {
                            const item = data.find(it => it.key === media.itemKey);
                            if (item) {
                              removeMedia(item.id, media.id);
                              break;
                            }
                          }
                        }}
                        className="bg-white rounded-full p-1 shadow-md hover:bg-red-100"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white text-xs px-2 py-1 truncate">
                    {getLabelLocal(media.itemKey)}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-2 text-sm text-gray-600" style={{ color: brand.black }}>
              {t.noPhotos || 'No photos added yet.'}
            </div>
          )}
        </div>

        {/* TOILET CLOGGING WARNING BOX moved to Page 3 (DB page_group=page3). Empty div kept. */}
        <div id="toilet-warning-box" />

        {SHOW_PER_PAGE_SIGNATURES && !isFrozen && (<SignatureBox
          brand={brand}
          lang={lang}
          onSignChange={setSignatureImage}
          onImageChange={setSignatureImage}
          initialImage={signatureImage}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
          pageNumber={3}
        />)}

        <ActionButtons 
          onPrevious={handlePrevious}
          onSave={handleSave}
          onPDF={handlePDF}
          onNext={handleNext}
          t={t}
        />

      </div>

      {showCamera && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-2xl w-full">
            <h3 className="text-xl font-bold mb-4" style={{ color: brand.black }}>Camera</h3>
            <video ref={videoRef} autoPlay playsInline className="w-full rounded-lg mb-4" style={{ maxHeight: '60vh' }} />
            <canvas ref={canvasRef} className="hidden" />
            <div className="flex gap-3">
              <button 
                onClick={capturePhoto} 
                className="flex-1 px-6 py-3 rounded-lg font-semibold text-white flex items-center justify-center gap-2" 
                style={{ backgroundColor: brand.blue }}
              >
                📸 {lang === 'el' ? 'Λήψη' : 'Capture'}
              </button>
              <button 
                onClick={closeCamera} 
                className="px-6 py-3 rounded-lg font-semibold border-2"
                style={{ borderColor: brand.black, color: brand.black }}
              >
                {lang === 'el' ? 'Κλείσιμο' : 'Close'}
              </button>
            </div>
          </div>
        </div>
      )}

      {zoomUrl && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4" onClick={() => setZoomUrl(null)}>
          <img src={zoomUrl} alt="Zoomed" className="max-w-[90%] max-h-[90%] rounded-lg shadow-2xl" />
        </div>
      )}

      {/* Floating Chat Widget */}
    </div>
  );
}